import { FormInput, Grid } from '@kirz/mui-admin';
import React from 'react';

import { StepWrapper } from '../StepWrapper';

export default function Step() {
  return (
    <StepWrapper
      name="Adres"
      description="Typ hieronder je volledige adres (indien correct druk op 'volgende')"
      backwardStep={(data) => {
        return data['burgerlijke_staat'] === 'Gehuwd' ||
          data['burgerlijke_staat'] === 'Wettelijk samenwonend'
          ? 1
          : 4;
      }}
    >
      <Grid container spacing={4}>
        <FormInput
          name="adres"
          label="Adres"
          placeholder="Vul je volledige adres in"
          xs={12}
          required
          multiline
          rows={3}
        />
      </Grid>
    </StepWrapper>
  );
}
